/**
 * 充值档列表行为模块, 拉取获取、处理用户操作等
 * @author zhenn
 * @time 2016-11-17
 */
import React, { Component } from "react";
import Pbajax from "up-pbajax";
import publicpb from "../global/publicpb";
import optionlistpb from "./optionlistpb";
import loading from "c-loading";
import channelConfig, { switchChannel } from "../global/channel-config";
import Notification from "../global/notification";
import lang from "../lang/index";
import global from "../global/global";
import url from "c-url";
import Dialog from "c-dialog";

export default (ComposedComponent) => {
    return class OptionListAct extends Component {
        static defaultProps = {
            onSelectPay() {},
            uid: "",
        };

        constructor(props) {
            super(props);
            this.state = {
                list: [],
            };
        }

        componentWillMount() {
            this.pbajax = new Pbajax();
            this.getOptionList(this.props.uid);
        }

        getOptionList(uid) {
            let self = this;
            loading.show({
                text: "loading",
            });

            // console.log('拉取充值档：', {
            //     uid,
            //     channel: channelConfig.option
            // });

            this.pbajax.do(
                {
                    service: "mall-recharge",
                    api:
                        channelConfig.option == "bk_atm"
                            ? "/recharge/config/bkatm"
                            : "/recharge/config/h5",
                    header: {},
                    inchina: 1,
                },

                new optionlistpb.Mall.RechargeConfig.Request({
                    uid,
                    channel: channelConfig.option,
                }),

                (res) => {
                    let dataWrap = publicpb.Result.decode(res);

                    if (dataWrap.code == 1) {
                        loading.hide();

                        if (dataWrap.data.value === null) {
                            console.log("option == null");
                        } else {
                            let data =
                                optionlistpb.Mall.RechargeConfig.Response.decode(
                                    dataWrap.data.value
                                );
                            console.log("充值档返回：", data);
                            self.setState({
                                list: data.rechargeConfigs,
                            });
                        }
                    } else {
                        if (channelConfig.option == "paypal") {
                            loading.hide();
                            let dialog = new Dialog({
                                content: lang.template(
                                    "PayPal充值不可用，是否前往Vip充值？"
                                ),
                                type: "confirm",
                            });
                            dialog.on("create", function () {
                                let el = $(this.get("el"));
                                el.find("[data-id=confirm]").html(
                                    lang.template("确定")
                                );
                                el.find("[data-id=close]").html(
                                    lang.template("取消")
                                );
                            });
                            dialog.create();
                            dialog.on("confirm", () => {
                                window.location.href =
                                    "./exception.html?lang=" +
                                    url.query("lang");
                            });
                        } else {
                            loading.hide();
                            new Notification({
                                content: lang.template("系统错误"),
                            }).create();
                        }
                    }
                }
            );
        }
        componentWillUnmount() {
            this.pbajax.cancel();
        }

        render() {
            return <ComposedComponent {...this.state} {...this.props} />;
        }
    };
};



// WEBPACK FOOTER //
// ./js/orderview/option-list-generator.js